import {
  GET_STOCK_AVAILABILITY_FAILURE,
  GET_STOCK_AVAILABILITY_REQUEST,
  GET_STOCK_AVAILABILITY_SUCCESS,
  DOWNLOAD_STOCK_AVAILABILITY_REQUEST,
  DOWNLOAD_STOCK_AVAILABILITY_SUCCESS,
  DOWNLOAD_STOCK_AVAILABILITY_FAILURE,
} from "./stockAvailabilityTypes";

const initialStateForStockAvailability = {
  loading: false,
  stockAvailability: [],
  error: "",
};

const getStockAvailabilityReducer = (
  state = initialStateForStockAvailability,
  action
) => {
  switch (action.type) {
    case GET_STOCK_AVAILABILITY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_STOCK_AVAILABILITY_SUCCESS:
      return {
        loading: false,
        stockAvailability: action.payload,
        error: "",
      };
    case GET_STOCK_AVAILABILITY_FAILURE:
      return {
        loading: false,
        stockAvailability: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForDownloadStockAvailabilityReport = {
  loading: false,
  stockAvailabilityReport: [],
  error: "",
};

const downloadStockAvailabilityReducer = (
  state = initialStateForDownloadStockAvailabilityReport,
  action
) => {
  switch (action.type) {
    case DOWNLOAD_STOCK_AVAILABILITY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DOWNLOAD_STOCK_AVAILABILITY_SUCCESS:
      return {
        loading: false,
        stockAvailabilityReport: action.payload,
        error: "",
      };
    case DOWNLOAD_STOCK_AVAILABILITY_FAILURE:
      return {
        loading: false,
        stockAvailabilityReport: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export { getStockAvailabilityReducer, downloadStockAvailabilityReducer };
